import dataOffersFrFr from './offers_fr_fr.js';
import dataOffersEnEn from './offers_en_en.js';

const dataOffers = {
  'fr-FR': dataOffersFrFr,
  'en-EN': dataOffersEnEn,
  'be-EN': dataOffersEnEn,
  'be-FR': dataOffersFrFr,
  'en-BE': dataOffersEnEn,
  'fr-BE': dataOffersFrFr,
};

export default dataOffers;
